import React, { useState } from "react";
import { Modal, Button } from 'react-bootstrap';
import './modal-styles.css';

export const AddNewColumn = (props) => {

    const [columnName, setColumnName] = useState("");
    const label = "New Column Name";
    
    const onHide = () => {
        setColumnName("");
    };

    return props.show ?
        (
            <Modal
                show={props.show}
                onHide={props.handleCancel}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add New Column</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-12">
                        <label className="form-label col-form-label col-md-4 modal-label">{label}</label>
                        <div className="col-md-8">
                            <input type="text" className="form-control" placeholder={label} value={columnName} onChange={e => setColumnName(e.target.value)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => { onHide(); props.handleCancel(); }}>
                        Cancel
                    </Button>
                    {columnName && columnName.length > 0 ?
                        <Button variant="primary" onClick={() => { props.handleSave({ columnName: columnName, selectedProject: props.selectedProject}); onHide(); }}>
                            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>
                            Add
                        </Button> :
                        <>
                            Not Yet Valid
                        </>
                    }
                </Modal.Footer>
            </Modal>
        ) :
        (<></>);

}